/**
 * Developer Routes Configuration
 * Routes are now centralized in config/CentralizedRoutes.js
 * This file imports routes from centralized configuration
 */
import { CENTRALIZED_ROUTE_MAP } from '../config/CentralizedRoutes';
import { Navigate } from 'react-router-dom';

// Redirect component for root developer path
const RedirectToDeveloperDashboard = () => <Navigate to="/developer/dashboard" replace />;

/**
 * Convert centralized route map to React Router route format for developer
 */
export const developerRoutes = [
  { path: '', element: RedirectToDeveloperDashboard },
  ...Object.entries(CENTRALIZED_ROUTE_MAP)
    .filter(([routePath]) => routePath.startsWith('/developer'))
    .map(([routePath, Component]) => {
      // Remove '/developer' prefix for React Router nested routes, preserving dynamic segments
      let path = routePath.replace('/developer', '') || 'dashboard';
      // Ensure dynamic routes are preserved
      if (path.startsWith('/')) {
        path = path.substring(1);
      }
      
      // Handle redirects for unified pages with tabs
      if (routePath === '/developer/integration-dashboard') {
        return {
          path,
          element: () => <Navigate to="/developer/dashboard?tab=integration" replace />
        };
      }
      
      return {
        path,
        element: Component
      };
    })
];

export default developerRoutes;
